module.exports = __webpack_public_path__ + "ee.c4fc3d97.jpg";